export default {
    title: 'Organisationsstatus ändern',
    toggleText: 'Möchtest du die ausgewählten Organisationen aktivieren / deaktivieren?',
    activate: 'Aktivieren',
    deactivate: 'Deaktivieren'
}